import { render, staticRenderFns } from "./RelatorioPDF.vue?vue&type=template&id=670f1528&scoped=true&"
import script from "./RelatorioPDF.vue?vue&type=script&lang=js&"
export * from "./RelatorioPDF.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioPDF.vue?vue&type=style&index=0&id=670f1528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f1528",
  null
  
)

export default component.exports